<template>
	<div class="checkin">
		<CompanyInfos></CompanyInfos>
		<hr class="divider" />
		<ReservationInfos></ReservationInfos>
		<GuestData v-for="guest in parseInt(guests)" :key="guest" :guest_number="guest" ref="guests"></GuestData>
		<PrivacyPolicy ref="privacy"></PrivacyPolicy>
		<ButtonFullWidth :callback="sendWebCheckIn" :text="getTranslation('SEND_CHECK_IN')"></ButtonFullWidth>
		<FieldsError :error_text="error_text"></FieldsError>
	</div>
</template>

<script>
	import CompanyInfos from '@/components/CompanyInfos.vue'
	import ReservationInfos from '@/components/ReservationInfos.vue'
	import GuestData from '@/components/GuestData.vue'
	import PrivacyPolicy from '@/components/PrivacyPolicy.vue'
	import ButtonFullWidth from '@/components/ButtonFullWidth.vue'
	import FieldsError from '@/components/FieldsError.vue'

	import jQuery from 'jquery'
	let $ = jQuery

	export default {
		name: 'CheckIn',
		components: {
			CompanyInfos,
			ReservationInfos,
			GuestData,
			PrivacyPolicy,
			ButtonFullWidth,
			FieldsError
		},
		inject: ['$axios'],
		data() {
			return {
				error_text: ''
			}
		},
		computed: {
			guests: function() {
				return this.$store.state.guests;
			},
		},
		methods: {
			resizeImage: function(file, maxWidth) {
				return new Promise((resolve, reject) => {
					const reader = new FileReader();

					reader.onload = (e) => {
					const img = new Image();
					img.onload = () => {
						let width = img.width;
						let height = img.height;

						if (width > maxWidth) {
						height = Math.floor((height * maxWidth) / width);
						width = maxWidth;
						}

						const canvas = document.createElement('canvas');
						canvas.width = width;
						canvas.height = height;
						const ctx = canvas.getContext('2d');
						ctx.drawImage(img, 0, 0, width, height);

						canvas.toBlob(
						(blob) => {
							if (blob) {
							const resizedFile = new File([blob], file.name, {
								type: file.type,
								lastModified: Date.now(),
							});
							resolve(resizedFile);
							} else {
							reject(new Error('Errore nel ridimensionamento'));
							}
						},
						file.type,
						0.9
						);
					};
					img.onerror = reject;
					img.src = e.target.result;
					};

					reader.onerror = reject;
					reader.readAsDataURL(file);
				});
			},
			getTranslation: function(key) {
				return this.$store.getters.get_translation(key);
			},
			async sendWebCheckIn() {
				let all_ok = true;
				for(let guest_index in this.$refs.guests) {
					let guest_all_ok = this.$refs.guests[guest_index].checkData();
					if(!guest_all_ok) {
						all_ok = false;
					}
				}

				if(!all_ok) {
					this.error_text = this.getTranslation('FILL_ALL_FIELDS');
				} else {
					if(!this.$refs.privacy.checkData()) {
						all_ok = false;
					}

					if(!all_ok) {
						this.error_text = this.getTranslation('ACCEPT_PRIVACY_POLICY');
					} else {
						var guests = [];
						for(let guest_index in this.$refs.guests) {
							guests.push(this.$refs.guests[guest_index].getData());
						}

						var self = this

						self.$store.commit('setStatus', 0);

						var img = null
						var img2 = null
						var img3 = null
						var bodyFormData = new FormData();
						bodyFormData.append('vat', self.$store.state.vat);
						bodyFormData.append('reservation_id', self.$store.state.reservation_pms_id);
						bodyFormData.append('reservation_room_id', self.$store.state.reservation_room_id);
						bodyFormData.append('guests', JSON.stringify(guests));
						if(guests[0].photo != null) {
							img = await this.resizeImage(guests[0].photo, 250);
						}
						if(guests[0].photo2 != null && guests[0].photo3 != null) {
							img2 = await this.resizeImage(guests[0].photo2, 800);
							img3 = await this.resizeImage(guests[0].photo3, 800);
						}
						bodyFormData.append('photo', img);
						bodyFormData.append('photo2', img2);
						bodyFormData.append('photo3', img3);

						self.$axios({
							method: 'post',
							url: '/checkin/'+self.$store.state.database+'/saveCheckInData',
							data: bodyFormData
						}).then(function (response) {
							if(response.data == 1) {
								self.$store.commit('setStatus', 2);
							} else {
								self.$store.commit('setStatus', -1);
							}
						});
					}
				}
				
			}
		},
		updated: function() {
			var self = this

			$('input').unbind('focus');
			$('input').focus(function() {
				$(this).removeClass('invalid_input');
				$(this).siblings('label').find('.error').html('');
				self.error_text = ''
			});

			$('select').unbind('focus');
			$('select').focus(function() {
				if($(this).attr('id').includes('birthstate') || $(this).attr('id').includes('state') || $(this).attr('id').includes('identitydocumentstate')) {
					$(this).parent().next().find('input').removeClass('invalid_input');
					$(this).parent().next().find('input').siblings('label').find('.error').html('');
				}
				self.error_text = ''
			});
		},
	}
</script>

<style type="text/css" scoped>
	.checkin {
		width: calc(100% - 100px);
		margin: 0 auto;
	}

	.divider {
		border: none;
		border-top: 3px solid var(--mainColor);
		margin-top: 20px;
		margin-bottom: 30px;
	}
</style>